import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetApplicationInfo = createAsyncThunk(
  "GetApplicationInfo",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ApplicationInfo/GetApplicationInfo",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      const data = response.data.result;
      console.log(data, "asdasdasdasd");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ApplicationInfo = createSlice({
  name: "ApplicationInfo",
  initialState: {
    ApplicationInfo: {},
    loadingApplicationInfo: false,
    errorApplicationInfo: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetApplicationInfo.pending, (state, action) => {
        state.loadingApplicationInfo = true;
        state.ApplicationInfo = action.payload;
        state.errorApplicationInfo = null;
      })
      .addCase(GetApplicationInfo.fulfilled, (state, action) => {
        state.loadingApplicationInfo = false;
        state.ApplicationInfo = action.payload;
      })
      .addCase(GetApplicationInfo.rejected, (state, action) => {
        state.loadingApplicationInfo = false;
        state.errorApplicationInfo = action.payload;
      });
  },
});
export default ApplicationInfo.reducer;
